var map = {
	"./ar.json": [
		3474,
		474
	],
	"./de.json": [
		8906,
		906
	],
	"./en-old.json": [
		2022,
		22
	],
	"./en.json": [
		3026,
		26
	],
	"./es.json": [
		6193,
		193
	],
	"./fr.json": [
		8137,
		137
	],
	"./languages/ar.json": [
		8642,
		642
	],
	"./languages/de.json": [
		3114,
		114
	],
	"./languages/en-old.json": [
		5942,
		942
	],
	"./languages/en.json": [
		1890,
		890
	],
	"./languages/es.json": [
		1089,
		89
	],
	"./languages/fr.json": [
		6169,
		169
	],
	"./languages/nl.json": [
		7187,
		187
	],
	"./languages/pt.json": [
		1961,
		961
	],
	"./languages/tr.json": [
		7364,
		983
	],
	"./nl.json": [
		8723,
		723
	],
	"./pt.json": [
		7817,
		817
	],
	"./tr.json": [
		2823,
		823
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4396;
module.exports = webpackAsyncContext;